<template>
  <v-row dense>
    <v-col cols="12" md="12">
      <v-card tile flat class="userBriefHistory" :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
        <v-container>
          <v-row dense>
            <!-- Start Title with Modal -->
            <v-col cols="12">
              <v-sheet class="d-flex align-center mb-4 justify-space-between flex-column flex-sm-row"
                :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
                <!-- Title -->
                <div class="title">
                  <v-img class="mr-3" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
                  <span>
                    {{ partner_summary.user_name }}
                    ({{ partner_summary.user_id }})</span>
                </div>
                <!-- Modal -->
                <div class="startingTips">
                  <v-dialog transition="scale-transition" origin="center center" content-class="deposit-withdraw-popup">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn plain class="text-capitalize pr-0" v-bind="attrs" v-on="on">
                        <v-img class="mr-1" max-width="14" src="@/assets/Dashboard/tips.svg"></v-img>
                        <b>Starting Tips</b></v-btn>
                    </template>
                    <template v-slot:default="dialog">
                      <v-card class="rounded-0" :class="$vuetify.theme.dark ? 'blue-darken-5' : 'secondary2'
                        ">
                        <v-card-title class="rounded-0">Starting Tips</v-card-title>
                        <ol>
                          <li v-for="detail in details" :key="detail.id">
                            {{ detail.para }}
                          </li>
                        </ol>
                      </v-card>
                    </template>
                  </v-dialog>
                </div>
              </v-sheet>
            </v-col>
            <!-- End Title with Modal -->

            <!-- Start User Statistics History -->
            <v-col cols="6" sm="6" md="4" lg="2" v-for="card in cards" :key="card.id">
              <v-sheet :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                ">
                <v-card-text class="trade">
                  <div class="icon-wrapper">
                    <div class="icon-box" :class="card.iconClass">
                      <v-icon :size="18" class="dash-icon">{{ card.icon }}</v-icon>
                    </div>

                    <div class="icon-content">
                      <h3>{{ card.title }}</h3>
                      <span>{{ card.subTitle }}</span>
                    </div>
                  </div>

                  <p class="amount">
                    {{ getCardAmount(card?.dataKey) || 0.00 }}
                    <span class="small-dashboard"
                      v-if="card?.dataKey != 'referralAccounts' && card?.dataKey != 'totalVolume'">$</span>
                  </p>
                </v-card-text>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { DASHBOARD__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    cards: [
      {
        id: 1,
        icon: "mdi-currency-usd",
        iconClass: "bg-balance",
        title: "Balance",
        subTitle: "IB Balance",
        dataKey: "ib_balance",
      },
      {
        id: 2,
        icon: "mdi-chart-bar",
        iconClass: "bg-volume",
        title: "Volume",
        subTitle: "Total Lots",
        dataKey: "totalVolume",
      },
      {
        id: 3,
        icon: "mdi-cash-multiple",
        iconClass: "bg-earning",
        title: "Earning",
        subTitle: "Commissions",
        dataKey: "totalEarning",
      },
      {
        id: 4,
        icon: "mdi-account-multiple-outline",
        iconClass: "bg-referral",
        title: "Referral",
        subTitle: "Total Clients",
        dataKey: "referralAccounts",
      },
      {
        id: 5,
        icon: "mdi-cash-minus",
        iconClass: "bg-withdraw",
        title: "Withdraw",
        subTitle: "By Partner",
        dataKey: "totalWithdraw",
      },
      {
        id: 6,
        icon: "mdi-cash-plus",
        iconClass: "bg-deposit",
        title: "Deposit",
        subTitle: "By Client",
        dataKey: "totalDepositByClient",
      },
    ],

    details: [
      {
        id: 1,
        para: "Payments from third parties are not accepted. The name of the sender must match the name on your trading account.",
      },
      {
        id: 2,
        para: "We accept wire transfers in USD. Funds sent in a different currency will be converted to the deposit currency of your account. You may be charged a fee for the conversion.",
      },
      {
        id: 3,
        para: "The sending bank or correspondent bank may deduct a fee for processing a wire transfer. We do not apply any fees and will deposit to your account the net amount received.",
      },
      {
        id: 4,
        para: " The sending bank or correspondent bank may deduct a fee for processing a wire transfer. We do not apply any fees and will deposit to your account the net amount received.",
      },
      {
        id: 5,
        para: "If the transaction goes through, the funds will be posted to your trading account upon receipt by us.",
      },
    ],
  }),

  computed: {
    ...mapState("dashboard", ["partner_summary"]),
  },

  methods: {
    ...mapActions("dashboard", [DASHBOARD__ACTIONS.PARTNERSUMMARY]),
    getCardAmount(dataKey) {
      const value = this.partner_summary[dataKey];
      return value !== undefined && value !== null ? value : "0.00";
    },
  },

  async mounted() {
    try {
      await this[DASHBOARD__ACTIONS.PARTNERSUMMARY]();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style>
.small-dashboard {
  font-size: 15px;
  font-weight: 300;
  opacity: .6;
}

.icon-wrapper {
  display: flex;
  align-items: center;

}

.icon-box {
  width: 31px;
  height: 31px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dash-icon {
  color: #ffffff !important;
}

.bg-balance {
  background: #0064167c;
}

.bg-volume {
  background: #d390002a;
}

.bg-earning {
  background: #ff09de3d;
}

.bg-referral {
  background: #2e7cdc49;
}

.bg-withdraw {
  background: #7a2f3b60;
}

.bg-deposit {
  background: #1f8a8a5b;
}
</style>
